import { ExternalLink } from "lucide-react";
import { sourceHost, type StartingTeacherSource } from "../data/starting-teacher-sources.js";

export function StartingTeacherSources({ sources }: { sources: readonly StartingTeacherSource[] }) {
  return (
    <ul className="space-y-3">
      {sources.map((source) => {
        const host = sourceHost(source.href);
        return (
          <li key={source.id}>
            <a
              className="flex flex-col rounded-2xl border border-border bg-background p-4 transition-colors hover:border-primary/40 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
              data-control-id={`starting-teacher.source.${source.id}`}
              href={source.href}
              rel="noopener noreferrer"
              target="_blank"
            >
              <span className="flex items-start justify-between gap-3">
                <span className="text-sm font-medium leading-snug">{source.title}</span>
                <ExternalLink aria-hidden="true" className="size-4 shrink-0 text-muted-foreground" />
              </span>
              <span className="mt-3 flex items-center gap-1.5 text-sm text-muted-foreground">
                <ExternalLink aria-hidden="true" className="size-3.5 shrink-0" />
                {host}
              </span>
            </a>
          </li>
        );
      })}
    </ul>
  );
}
